<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="ground" title="솔루션" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                스마트팜 제품 솔루션
            </template>
            <tit-wrap-large>
                토양환경 데이터를 취득하여 <br class="d-none d-lg-block" />작물이 필요한 요소를 측정하는 <b>노지스마트팜</b>
                <template #text> 인위적인 환경 관리가 힘든 노지재배에서 작물이 필요로 하는 적정한 물과 영양분 공급으로 <br class="d-none d-lg-block" />효율적인 토양재배환경 관리가 가능하며 농작물 재배의 효율과 생산성을 높여줍니다. <br class="d-none d-lg-block" />노지재배 환경과 근권부(작물의 뿌리 주변) 환경을 지속적으로 모니터링하여 필요 영양분 <br class="d-none d-lg-block" />공급과 관수제어로 최적의 생육환경을 유지할 수 있습니다. </template>
            </tit-wrap-large>
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section>
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-responsive :aspect-ratio="570 / 456" content-class="d-flex">
                                    <v-img max-width="570" :aspect-ratio="570 / 456" src="/images/sub/solution/smartfarm/ground-img.jpg" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div>
                                <tit-wrap-sprout>
                                    노지 스마트팜
                                    <template #text>
                                        작물재배 토양 데이터 취득 장비
                                    </template>
                                </tit-wrap-sprout>

                                <txt-item>
                                    <template #title>측정항목</template>
                                    외부 온도, 습도, 일사 / 토양의 온도, 습도, EC, 수분
                                </txt-item>
                                <div class="mt-16px mt-md-24px">
                                    <v-img max-width="436" :aspect-ratio="436 / 272" src="/images/sub/solution/smartfarm/ground-img2.png" />
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card rounded="" color="grey lighten-5" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="600" :width="$vuetify.breakpoint.lgAndUp ? '600' : ''" :aspect-ratio="600 / 376" src="/images/sub/solution/smartfarm/ground-img3.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        웹과 모바일에서 쉽고 간편한 실시간 모니터링
                                        <template #text>작물재배 토양의 정보를 웹과 모바일에서 간편하게 모니터링이 가능합니다.</template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section id="ground-portfolio" class="page-section--last">
            <template #title>
                포트폴리오
            </template>
            <div></div>

            <template #pageSectionImmersive>
                <div style="max-width:1480px" class="mx-auto px-12px">
                    <ground-slide />
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";
import GroundSlide from "@/pages/client/sub/solution/GroundSlide.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
        GroundSlide,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
